import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "发票邮寄信息")
], -1)
const _hoisted_4 = {
  key: 1,
  class: "form-dialog__content"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "默认开票种类")
], -1)
const _hoisted_6 = { class: "form-dialog__content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票内容")
], -1)
const _hoisted_8 = { class: "form-dialog__content" }
const _hoisted_9 = { style: {"margin-right":"15px"} }

import {
  withDefaults,
  ref,
  onMounted,
  computed,
  watch,
  isRef
} from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  useCreateModal,
  BaseFormItem,
  BaseRadioGroup,
  BaseRadio,
  BaseSelect,
  BaseInput,
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseTable,
  BaseForm
} from 'xrk-components';
import {
  basicInformation,
  invoiceCategory,
  contentOfMakeOutAnInvoice,
  makeOutAnInvoiceDk
} from '@V/invoice/src/data-source/apis';
import {
  BasicInformationData,
  MakeOutAnInvoiceDkParams
} from '@V/invoice/src/data-source/types';
import { INVOICE_TYPE } from '@V/invoice/src/constants/index';
import { formatter } from '@/utils';
import InvoiceWtdk4Dialog from './invoice-wtdk-4-dialog.vue';
import { NotInvoicedListItem } from '@V/invoice/src/data-source/types';
import { useCloned } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-wtdk-3-dialog',
  props: {
    orders: {},
    remove: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const xrkTableRef = ref(null);
const totalPrice = ref(0);
const items = ref<BasicInformationData['itemList']>([]);
const addressList = ref<BasicInformationData['addressList']>([]);
const formData = ref<MakeOutAnInvoiceDkParams>({
  openOrderIdList: props.orders.reduce((pre, cur) => {
    const ids = cur._selections.map(item => item.openOrderId);
    [].push.apply(pre, ids);
    return pre;
  }, []),
  itemId: null,
  itemName: '',
  addressId: null,
  invoiceType: 1,
  sonList: [],
  invoiceMethod: 0
});

const curAddress = computed(() => {
  return addressList.value.find(item => item.id === formData.value.addressId);
});

const remoteItems = arr => {
  return Promise.resolve({
    data: isRef(arr) ? arr.value : arr
  });
};
// 发票类目控制列表重载
const getListAjax = async params => {
  // 发票类别、发票类目要求必传，但是内部可编辑两项，所以必传是没用的。
  const resp = await contentOfMakeOutAnInvoice({
    ...params,
    ...formData.value // 列表需要的入参包含在了form里，直接使用
  });
  // 总额
  totalPrice.value = resp.data.maximumAmountInvoiced;
  // 设置row中数据，外面的类别、类目修改后重新给row赋值与默认值
  resp.data.list.forEach((item, index) => {
    const { cloned } = useCloned(items.value);
    item._items = cloned.value;
    item._key = `${index}_${Date.now()}`;
    item.itemId = formData.value.itemId;
    item.itemName = formData.value.itemName;
    item.invoiceType = formData.value.invoiceType;
  });
  return resp;
};
const setItems = async invoiceType => {
  items.value = []; // 置空是为了让select组件重载，触发remoteMethod
  // 委托代发stateType写死
  const { data } = await invoiceCategory({ stateType: 2, invoiceType });
  items.value = data;
  // 默认选中第一个，解决列表入参该字段是必选且列表无所搜按钮的产品问题
  formData.value.itemId = data[0].id;
  formData.value.itemName = data[0].itemName;
  onItemChange(data[0].id, [data[0]]);
};

const onItemChange = (v, options) => {
  formData.value.itemName = options[0].itemName;
  xrkTableRef.value.initList();
};
const onConfirm = async () => {
  const { data } = await makeOutAnInvoiceDk({
    ...formData.value,
    sonList: xrkTableRef.value.getTableData().value.map(item => {
      const { invoiceType, itemId, itemName, userId = 'no value' } = item;
      return { invoiceType, itemId, itemName, userId };
    })
  });
  // 仅查看
  useCreateModal(InvoiceWtdk4Dialog, {
    payload: data
  });
  emits('success');
  props.remove();
};

watch(
  () => formData.value.invoiceType,
  v => {
    // 初始与监听，全部依赖于发票类目
    setItems(v);
  },
  {
    immediate: true
  }
);

onMounted(() => {
  basicInformation().then(({ data }) => {
    addressList.value = data.addressList;
    // 赋值开票地址(第一个)默认项
    formData.value.addressId =
      data.addressList.find(item => item.isDefault)?.id || null;
  });
});

const searchConfig = ref<XrkTableProps['searchConfig']>({
  hide: true,
  searchColumns: [],
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  }
});
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'expand',
      fixed: 'left',
      width: 70,
      render({ row }) {
        return (
          <>
            <BaseTable
              data={row.sonList}
              columns={[
                useTableColumn({
                  label: '',
                  type: 'index',
                  width: '80px'
                }),
                useTableColumn({
                  label: '项目名称',
                  prop: 'projectName'
                }),
                useTableColumn({
                  label: '任务月度',
                  prop: 'taskAt',
                  formatter: ({ cellValue }) =>
                    formatter.date(cellValue, 'YYYY-MM')
                }),
                useTableColumn({
                  label: '开票金额',
                  prop: 'userDefinedPrice',
                  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
                })
              ]}
            />
          </>
        );
      }
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '项目参与人',
      prop: 'name'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '开票金额',
      prop: 'userDefinedPrice',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '发票类别',
      prop: 'invoiceType',
      width: '180px',
      render({ row, index }) {
        return (
          <BaseSelect
            v-model={row.invoiceType}
            options={INVOICE_TYPE}
            onChange={async v => {
              // 联动类目
              const { data } = await invoiceCategory({
                stateType: 2,
                invoiceType: v
              });
              row._items = data;
              row.itemName = data[0].itemName;
              row.itemId = data[0].id;
              row._key = `${index}_${Date.now()}`;
            }}
          />
        );
      }
    }),
    useTableColumn({
      label: '发票类目',
      prop: 'itemId',
      width: '180px',
      render({ row }) {
        return (
          <BaseSelect
            labelKey="itemName"
            valueKey="id"
            key={row._key}
            init
            remoteMethod={() => remoteItems(row._items)}
            v-model={row.itemId}
            onChange={(v, option) => {
              row.itemName = option[0].itemName;
            }}
          />
        );
      }
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120",
    title: "申请开票",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), { click: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("确认开票")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref: "formRef",
            "label-position": "right",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "发票方式",
                    prop: "invoiceMethod"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseRadioGroup), {
                        modelValue: formData.value.invoiceMethod,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.invoiceMethod) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseRadio), {
                            disabled: "",
                            value: 0
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("纸质发票")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_3,
                (addressList.value.length)
                  ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                      key: 0,
                      label: "收件地址",
                      prop: "addressId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseSelect), {
                          class: "form-dialog__w280",
                          placeholder: "请选择",
                          modelValue: formData.value.addressId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.addressId) = $event)),
                          options: 
                addressList.value.map(item => {
                  return { label: item.mailAddress, value: item.id };
                })
              
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (curAddress.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(BaseFormItem), {
                        label: "收件人",
                        prop: "name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseInput), {
                            class: "form-dialog__w280",
                            type: "text",
                            placeholder: "请输入",
                            disabled: "",
                            modelValue: curAddress.value.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((curAddress.value.name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BaseFormItem), {
                        label: "联系方式",
                        prop: "phone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseInput), {
                            class: "form-dialog__w280",
                            type: "text",
                            placeholder: "请输入",
                            disabled: "",
                            modelValue: curAddress.value.phone,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((curAddress.value.phone) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BaseFormItem), {
                        label: "发票邮寄地址",
                        prop: "mailAddress"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseInput), {
                            class: "form-dialog__w280",
                            type: "text",
                            placeholder: "请输入",
                            disabled: "",
                            modelValue: curAddress.value.mailAddress,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((curAddress.value.mailAddress) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BaseFormItem), {
                        label: "电子邮箱",
                        prop: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseInput), {
                            class: "form-dialog__w280",
                            type: "tel",
                            placeholder: "请输入",
                            disabled: "",
                            modelValue: curAddress.value.email,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((curAddress.value.email) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "发票类别",
                    prop: "invoiceType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseSelect), {
                        class: "form-dialog__w280",
                        placeholder: "请选择",
                        modelValue: formData.value.invoiceType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.invoiceType) = $event)),
                        options: _unref(INVOICE_TYPE)
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }),
                  (items.value.length)
                    ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                        key: 0,
                        label: "发票类目",
                        prop: "itemId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseSelect), {
                            class: "form-dialog__w280",
                            placeholder: "请选择",
                            labelKey: "itemName",
                            valueKey: "id",
                            init: "",
                            remoteMethod: () => remoteItems(items.value),
                            modelValue: formData.value.itemId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.itemId) = $event)),
                            onChange: onItemChange
                          }, null, 8, ["remoteMethod", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(XrkTable), {
                    ref_key: "xrkTableRef",
                    ref: xrkTableRef,
                    requestNow: false,
                    getListAjax: getListAjax,
                    searchConfig: searchConfig.value,
                    tableConfig: tableConfig.value
                  }, {
                    tableBefore: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_9, " 价税合计：" + _toDisplayString(_unref(formatter).fen2yuan(totalPrice.value)) + "元 ", 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["searchConfig", "tableConfig"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})